import { TrendingUp, DollarSign, Users, AlertCircle } from "lucide-react";

const AcademicRequirementsTracker = ({ athleteId: _athleteId }: { athleteId: string }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="rounded-xl border border-[#E0A458]/30 bg-[#0D1B2A]/60 p-4">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#E0A458] mb-2">Division I</p>
          <div className="flex items-end gap-4">
            <div>
              <p className="text-xs text-slate-400 mb-0.5">NCAA Floor</p>
              <p className="font-montserrat font-bold text-2xl text-white">2.3</p>
            </div>
            <div className="border-l border-[#415A77]/60 pl-4">
              <p className="text-xs text-slate-400 mb-0.5">Coaches Want</p>
              <p className="font-montserrat font-bold text-2xl text-[#E0A458]">3.0+</p>
            </div>
          </div>
        </div>
        <div className="rounded-xl border border-[#415A77]/40 bg-[#0D1B2A]/60 p-4">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#E0A458] mb-2">Division II</p>
          <div className="flex items-end gap-4">
            <div>
              <p className="text-xs text-slate-400 mb-0.5">NCAA Floor</p>
              <p className="font-montserrat font-bold text-2xl text-white">2.2</p>
            </div>
            <div className="border-l border-[#415A77]/60 pl-4">
              <p className="text-xs text-slate-400 mb-0.5">Coaches Want</p>
              <p className="font-montserrat font-bold text-2xl text-[#E0A458]">3.0+</p>
            </div>
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-[#415A77]/40 bg-[#0D1B2A]/50 p-4 space-y-3">
        <p className="text-sm font-semibold text-white">What coaches and recruiting services actually say</p>
        <ul className="space-y-3">
          <li className="flex items-start gap-2.5">
            <Users className="h-4 w-4 text-[#E0A458] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-300">85% of coaches say they are less likely to recruit an athlete with a low GPA, even if they are athletically elite and technically eligible.</p>
          </li>
          <li className="flex items-start gap-2.5">
            <AlertCircle className="h-4 w-4 text-[#E0A458] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-300">Coaches focus on recruits they know can get admitted. A 2.3 GPA may not clear a school's admissions bar even if it clears the NCAA eligibility threshold.</p>
          </li>
          <li className="flex items-start gap-2.5">
            <DollarSign className="h-4 w-4 text-[#E0A458] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-300">At DII schools, athletic and academic scholarships can be stacked. A stronger GPA means the school can reduce the family's actual cost significantly -- 83% of non-D1 schools confirm this. DIII schools do not offer athletic scholarships at all, so academics are the primary lever for financial aid.</p>
          </li>
          <li className="flex items-start gap-2.5">
            <TrendingUp className="h-4 w-4 text-[#E0A458] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-300">A 3.5+ GPA combined with strong athleticism is the profile that generates the most scholarship offers across all divisions.</p>
          </li>
        </ul>
      </div>

      <div className="flex items-start gap-3 rounded-xl border border-emerald-500/30 bg-emerald-900/20 p-3">
        <TrendingUp className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
        <p className="text-sm text-emerald-200">
          <span className="font-semibold">Bottom line:</span> The NCAA minimum is a survival number, not a recruiting number. Target 3.0+ to stay on coaches' radar and maximize scholarship potential at every level.
        </p>
      </div>
    </div>
  );
};

export default AcademicRequirementsTracker;
